// extracted by mini-css-extract-plugin
export default {"floatingCart":"Cart_floatingCart__qNZO4","emptyCart":"Cart_emptyCart__U6jGs","cartHeader":"Cart_cartHeader__QT0k6","dragHandle":"Cart_dragHandle__Mjtou"};